var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCohortAvgIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    stroke: "#BBC3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6666 17.9188V13.0013C23.6666 11.1604 22.1743 9.66797 20.3333 9.66797H11.1666C10.9825 9.66797 10.8333 9.8172 10.8333 10.0013V11.3379C10.8333 11.5866 10.9444 11.8224 11.1363 11.9807L12.3637 13.5434C12.5555 13.7017 12.6666 13.9374 12.6666 14.1862V17.9188V26.0013C12.6666 26.1855 12.8159 26.3346 13 26.3346H23.3333C23.5174 26.3346 23.6666 26.1855 23.6666 26.0013V17.9188Z",
    fill: "#6C7DE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.0013H12.6667C12.7057 15.0013 12.6667 11.5611 12.6667 11.168C12.6667 10.3395 11.9951 9.66797 11.1667 9.66797C10.3383 9.66797 9.66669 10.3395 9.66669 11.168V14.668C9.66669 14.8521 9.81592 15.0013 10 15.0013Z",
    fill: "#4B5ED2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8334 14.0013C14.8334 13.8172 14.9826 13.668 15.1667 13.668H20C20.1841 13.668 20.3334 13.8172 20.3334 14.0013C20.3334 14.1854 20.1841 14.3346 20 14.3346H15.1667C14.9826 14.3346 14.8334 14.1854 14.8334 14.0013Z",
    fill: "#D8DEFF",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8334 16.6693C14.8334 16.4852 14.9826 16.3359 15.1667 16.3359H17.8334C18.0175 16.3359 18.1667 16.4852 18.1667 16.6693C18.1667 16.8534 18.0175 17.0026 17.8334 17.0026H15.1667C14.9826 17.0026 14.8334 16.8534 14.8334 16.6693Z",
    fill: "#D8DEFF",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0834 18.974C15.0834 18.7899 15.2326 18.6406 15.4167 18.6406H17.75C17.9341 18.6406 18.0834 18.7899 18.0834 18.974C18.0834 19.1581 17.9341 19.3073 17.75 19.3073H15.4167C15.2326 19.3073 15.0834 19.1581 15.0834 18.974Z",
    fill: "#D8DEFF",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8334 22.0013C14.8334 21.8172 14.9826 21.668 15.1667 21.668H19.6667C19.8508 21.668 20 21.8172 20 22.0013C20 22.1854 19.8508 22.3346 19.6667 22.3346H15.1667C14.9826 22.3346 14.8334 22.1854 14.8334 22.0013Z",
    fill: "#D8DEFF",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 18.0013C16.6667 20.6707 18.8306 22.8346 21.5 22.8346C24.1694 22.8346 26.3334 20.6707 26.3334 18.0013C26.3334 15.3319 24.1694 13.168 21.5 13.168C18.8306 13.168 16.6667 15.3319 16.6667 18.0013Z",
    fill: "#5FEDD3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8333 15.5013C21.8333 15.3172 21.6841 15.168 21.5 15.168C21.3159 15.168 21.1666 15.3172 21.1666 15.5013V15.8346H20.5203C20.1424 15.8346 19.8359 15.9835 19.6282 16.223C19.4264 16.4558 19.3333 16.7554 19.3333 17.043C19.3333 17.3306 19.4264 17.6302 19.6282 17.8629C19.8359 18.1024 20.1424 18.2513 20.5203 18.2513H21.1666V19.3346H19.9123C19.7282 19.3346 19.579 19.4839 19.579 19.668C19.579 19.8521 19.7282 20.0013 19.9123 20.0013H21.1666V20.3346C21.1666 20.5187 21.3159 20.668 21.5 20.668C21.6841 20.668 21.8333 20.5187 21.8333 20.3346V20.0013H22.4796C22.8576 20.0013 23.164 19.8524 23.3717 19.6129C23.5736 19.3802 23.6666 19.0806 23.6666 18.793C23.6666 18.5054 23.5736 18.2058 23.3717 17.973C23.164 17.7335 22.8576 17.5846 22.4796 17.5846H21.8333V16.5013H22.9675C23.1515 16.5013 23.3008 16.3521 23.3008 16.168C23.3008 15.9839 23.1515 15.8346 22.9675 15.8346H21.8333V15.5013ZM21.1666 16.5013H20.5203C20.3291 16.5013 20.2087 16.5712 20.1319 16.6598C20.0492 16.7552 20 16.8931 20 17.043C20 17.1929 20.0492 17.3308 20.1319 17.4261C20.2087 17.5148 20.3291 17.5846 20.5203 17.5846H21.1666V16.5013ZM21.8333 18.2513V19.3346H22.4796C22.6708 19.3346 22.7912 19.2648 22.8681 19.1761C22.9508 19.0808 23 18.9429 23 18.793C23 18.6431 22.9508 18.5052 22.8681 18.4098C22.7912 18.3212 22.6708 18.2513 22.4796 18.2513H21.8333Z",
    fill: "#4B5ED2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCohortAvgIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cohort-avg-icon.d2fbc9a2de3670ad2efa6c0705b05796.svg";